
const apiConfig = {
    //Local
    //apiUrl: 'https://localhost:7143/api/',
    //Live

    //DEV
    apiUrl: 'https://payslip-api.solegaze.com/api/',
    apiKey: 'Lieda1002',
};

export default apiConfig;

